export * from './sidenav-shim.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/sidenav/index.ts